import { FC, ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import InfoIcon from "shared/icons/status-icons/info-icon.svg?react";
import { cx } from "shared/utils";

export // Same as Object Item styles
const ContentTitle: FC<{
  title: string;
  children: ReactNode;
  tooltip?: ReactNode;
  contentClassName?: string;
  titleVariant?: "default" | "medium";
}> = ({ title, children, tooltip, contentClassName, titleVariant }) => {
  return (
    // REMOVED PRINT HERE
    // <div className="mt-4 print:break-inside-avoid">
    <div className="mt-4">
      <h3
        className={cx(
          "border-b border-alpha-40 pb-2 flex items-center gap-2",
          titleVariant === "medium"
            ? "text-content-1000 text-sm font-medium"
            : "text-sm font-bold"
        )}
      >
        {title}
        {tooltip ? (
          <Tooltip>
            <TooltipTrigger>
              <InfoIcon className="w-4 h-4 text-content-200" />
            </TooltipTrigger>
            <TooltipContent className="max-w-[300px] rounded-lg border bg-alpha-800 p-4 text-sm text-white">
              {tooltip}
            </TooltipContent>
          </Tooltip>
        ) : null}
      </h3>
      <div className={cx("py-4", contentClassName)}>{children}</div>
    </div>
  );
};
